import React from "react";
import DesktopFooterEntry from "./DesktopFooterEntry";
import i18n from "~/assets/js/Helpers/i18n";

const DesktopUpperFooter = () => {
    return (
        <div className="desktop_footer">
            <DesktopFooterEntry
                heading={i18n.t("desktopFooter.firstEntry.heading")}
                content={i18n.t("desktopFooter.firstEntry.content")}
            />

            <DesktopFooterEntry
                heading={i18n.t("desktopFooter.secondEntry.heading")}
                content={i18n.t("desktopFooter.secondEntry.content")}
            />

            <DesktopFooterEntry
                heading={i18n.t("desktopFooter.thirdEntry.heading")}
                content={i18n.t("desktopFooter.thirdEntry.content")}
            />

            <DesktopFooterEntry
                heading={i18n.t("desktopFooter.fourthEntry.heading")}
                content={i18n.t("desktopFooter.fourthEntry.content")}
            />
        </div>
    );
};

export default DesktopUpperFooter;
